import { render, staticRenderFns } from "./boardStock.vue?vue&type=template&id=0b0c0702&scoped=true&"
import script from "./boardStock.vue?vue&type=script&lang=js&"
export * from "./boardStock.vue?vue&type=script&lang=js&"
import style0 from "./boardStock.vue?vue&type=style&index=0&id=0b0c0702&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0c0702",
  null
  
)

export default component.exports